<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:warehouseId>
        <el-select
          filterable
          clearable
          v-model="filters.warehouseId"
          placeholder="请选择仓库"
          @change="GetRepFeeType"
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:feeTypeID>
        <el-select
          v-model="filters.feeTypeID"
          placeholder="请选择费用类型"
          @change="GetRepFeeItem"
          filterable
          clearable
        >
          <el-option
            v-for="item in feeTypeRepList"
            :label="item.feeTypeName"
            :value="item.feeTypeID"
            :key="item.feeTypeID"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:feeItemID>
        <el-select
          v-model="filters.feeItemID"
          placeholder="请选择费用项"
          filterable
          multiple
        >
          <el-option
            v-for="item in feeItemRepList"
            :label="item.feeItemName"
            :value="item.feeItemID"
            :key="item.feeItemID"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:feeRuleID>
        <el-select
          multiple
          filterable
          v-model="filters.feeRuleID"
          placeholder="请选择费用规则"
        >
          <el-option
            v-for="item in feeRuleList"
            :label="item.feeRuleName"
            :value="item.feeRuleId"
            :key="item.feeRuleId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:orgID>
        <el-select
          v-model="filters.orgID"
          placeholder="请选择客户"
          multiple
          filterable
        >
          <el-option
            v-for="item in customerList"
            :label="item.customName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:status>
        <el-select
          v-model="filters.status"
          placeholder=" 请选择审核状态"
          multiple
          filterable
        >
          <el-option
            v-for="item in batchStatusList"
            :label="item.batchStatusText"
            :value="item.batchStatusId"
            :key="item.batchStatusId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:isStart>
        <el-select
          v-model="filters.isStart"
          placeholder="请选择是否启用"
          multiple
          filterable
        >
          <el-option
            v-for="item in isStartList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>

      <template v-slot:isOverdue>
        <el-select
          v-model="filters.isOverdue"
          placeholder="请选择是否过期"
          multiple
          filterable
          :multiple-limit="1"
        >
          <el-option
            v-for="item in isOverdueList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="batchNumber">
        <el-link
          :underline="false"
          type="primary"
          @click.native="feeItemBatchdetails(scope.row.feeItemBatchID)"
          >{{ scope.row.batchNumber }}
        </el-link>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 31, businessCode: currentRow.batchNumber }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
    <!-- 费用设置 -->
    <el-dialog
      id="completeDialog"
      title="费用设置"
      :visible.sync="addTaskdialogVisible"
      width="80%"
      top="70px"
      style="text-align: center"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addRuleForm"
        auto-complete="off"
        style="overflow-x: hidden; overflow-y: hidden; margin-right: 4%"
        :disabled="feeItemBatchdisabled"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="费用名称" prop="FeeCustomerName">
              <el-input
                v-model="addForm.FeeCustomerName"
                auto-complete="off"
                placeholder="请输入费用名称"
                maxlength="50"
                 :disabled="Editdisabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库" prop="WarehouseId">
              <el-select
                filterable
                v-model="addForm.WarehouseId"
                style="width: 100%"
                placeholder="请选择仓库"
                @change="GetFeeType"
                :disabled="Editdisabled"
              >
                <el-option
                  v-for="item in warehouseList"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                  :key="item.warehouseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="公共费用" prop="OrgIDS">
              <el-checkbox
                :disabled="Editdisabled"
                v-model="addForm.IsPublic"
                style="width: 10%"
                @change="selectCustomer"
              ></el-checkbox>
              <el-select
                v-model="addForm.OrgIDS"
                placeholder="请选择客户"
                style="width: 90%"
                multiple
                filterable
                :disabled="Orgdisabled"
              >
                <el-option
                  v-for="item in customerList"
                  :label="item.customName"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="币别" prop="Currency">
              <el-select
                filterable
                v-model="addForm.Currency"
                style="width: 100%"
                placeholder="请选择币别"
              >
                <el-option
                  v-for="item in currencyList"
                  :label="item.currencyName"
                  :value="item.currencyValue"
                  :key="item.currencyValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="费用类型" prop="FeeTypeID">
              <el-select
                v-model="addForm.FeeTypeID"
                style="width: 100%"
                placeholder="请选择费用类型"
                @change="GetFeeItem"
                :disabled="Editdisabled"
              >
                <el-option
                  v-for="item in feeTypeWareList"
                  :label="item.feeTypeName"
                  :value="item.feeTypeID"
                  :key="item.feeTypeID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费用项" prop="FeeItemID">
              <el-select
                v-model="addForm.FeeItemID"
                style="width: 100%"
                placeholder="请选择费用项"
                :disabled="Editdisabled"
              >
                <el-option
                  v-for="item in feeItemTypeList"
                  :label="item.feeItemName"
                  :value="item.feeItemID"
                  :key="item.feeItemID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期" prop="tdate">
              <el-date-picker
                :disabled="Editdisabled"
                v-model="addForm.tdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费用规则" prop="FeeRuleID">
              <el-select
                v-model="addForm.FeeRuleID"
                style="width: 100%"
                placeholder="请选择费用规则"
                @change="getFeeRuleTemp"
              >
                <el-option
                  v-for="(item, index) in feeRuleList"
                  :label="item.feeRuleName"
                  :value="item.feeRuleId"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="详细说明">
              <el-input
                v-model="addForm.Remark"
                auto-complete="off"
                placeholder="请输入详细说明"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="">
            <div class="otherTable">
              <el-table-bar :fixed="true" :bottom="35">
                <el-table
                  border
                  :data="ruleData"
                  style="width: 100%"
                  height="350"
                >
                  <el-table-column
                    v-for="(item, index) in ruleTitle"
                    :prop="item.TemplateFieldName"
                    :label="item.TemplateFieldAlias"
                    :key="index"
                    align="center"
                    min-width="120"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="
                          judgeStr(scope.row[item.TemplateFieldName]) === true
                        "
                      >
                        {{
                          scope.row[item.TemplateFieldName].replace(
                            "fixed20210916",
                            ""
                          )
                        }}
                      </div>
                      <div v-else>
                        <el-input
                          v-model="scope.row[item.TemplateFieldName]"
                          auto-complete="off"
                          maxlength="50"
                        ></el-input>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="操作"
                    min-width="100"
                    align="center"
                    v-if="
                      ruleTitle.length > 0 && feeItemBatchdisabled === false
                    "
                  >
                    <template slot-scope="scope">
                      <el-button @click="addRuleTemp()" type="text" size="small"
                        >添加</el-button
                      >

                      <el-button
                        @click="delRuleTemp(scope.row.xh)"
                        type="text"
                        size="small"
                        v-if="scope.row.xh > 1"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-table-bar>
              <div class="block">
                <el-pagination
                  layout="total"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </div>
            </div>
          </el-form-item>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          justify="center"
          v-if="feeItemBatchdisabled === false"
        >
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerList } from "@/api/ProductSkuExcel.js";
import {
  getFeeItemBatchBasis,
  getFeeRuleTemplateByFeeRuleId,
  AddFeeItemBatch,
  getFeeItemBatchByFeeItemBatchId,
  getFeeItemBatchAsync,
  exportFeeItemBatchAsyncOut,
  examineFeeItemBatchIsStart,
  examineFeeItemBatchStatus,
  recostingFeeFlowDetail,
} from "@/api/costManagement/expenseSetting.js";

import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";

export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          width: "200",
          options: [
            {
              name: "编辑",
              size: "small",
              type: "text",
              event: "editTaskdialog", // 操作的事件名
            },
            {
              name: "复制新增",
              size: "small",
              type: "text",
              event: "copyTaskdialog", // 操作的事件名
            },
            {
              name: "重算",
              size: "small",
              type: "text",
              event: "recalculation", // 操作的事件名
            },
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置

          {
            prop: "feeCustomerName",
            label: "费用名称",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "batchNumber",
            label: "批次号",
            align: "center",
            sortable: true,
            minWidth: "160",
            slot: true,
          },

          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "110",
          },

          {
            prop: "feeTypeName",
            label: "费用类型",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "feeItemName",
            label: "费用项",
            align: "center",
            sortable: true,
            minWidth: "110",
          },

          {
            prop: "feeRuleName",
            label: "费用规则",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "customer",
            label: "客户",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "effectiveDate",
            label: "有效期始",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "expirationDate",
            label: "有效期止",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "updateTime",
            label: "维护时间",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "statusText",
            label: "审核状态",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "isStartText",
            label: "启用/禁用",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "isOverdue",
            label: "倒计过期天数",
            align: "center",
            sortable: true,
            minWidth: "130",
          },
        ],
      },
      loadingReviewWinodw: "",
      loadingReviewdialogVisible: false,
      searchData: {
        //搜索列配置

        search: [
          {
            type: "select",
            key: "warehouseId",
            prop: "warehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouseList,
          },
          {
            type: "select",
            key: "feeTypeID",
            prop: "feeTypeID",
            label: "费用类型",
            multiple: true,
            slot: true,
            placeholder: "请选择费用类型",
            option: this.feeTypeList,
          },
          {
            type: "select",
            key: "feeItemID",
            prop: "feeItemID",
            label: "费用项",
            multiple: true,
            slot: true,
            placeholder: "请选择费用项",
            option: this.feeItemList,
          },
          {
            type: "select",
            key: "orgID",
            prop: "orgID",
            label: "客户",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.customerList,
          },
          {
            type: "select",
            key: "feeRuleID",
            prop: "feeRuleID",
            label: "费用规则",
            multiple: true,
            slot: true,
            placeholder: "请选择费用规则",
            option: this.feeRuleList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "status",
            prop: "status",
            label: "审核状态",
            multiple: true,
            slot: true,
            placeholder: "请选择审核状态",
            option: this.batchStatusList,
          },
          {
            type: "select",
            key: "isStart",
            prop: "isStart",
            label: "是否启用",
            multiple: true,
            slot: true,
            placeholder: "请选择是否启用",
            option: this.isStartList,
          },
          {
            type: "select",
            key: "isOverdue",
            prop: "isOverdue",
            label: "是否过期",
            multiple: true,
            slot: true,
            placeholder: "请选择是否过期",
            option: this.isOverdueList,
          },
        ],
      },
      buttonList: [],

      //-------------
      warehouseList: [],
      transportList: [],
      srcList: [],
      addTaskdialogVisible: false,

      addForm: {
        FeeItemBatchID: 0,
        FeeCustomerName: "",
        WarehouseId: "",
        Currency: "",
        FeeTypeID: "",
        FeeItemID: "",
        FeeRuleID: "",
        OrgIDS: [],
        tdate: [],
        IsPublic: false,
        Remark:"",
      },
      addFormRules: {
        FeeCustomerName: [
          { required: true, message: "请输入费用名称", trigger: "blur" },
        ],
        WarehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        OrgIDS: [],
        Currency: [
          { required: true, message: "请选择币别", trigger: "change" },
        ],
        FeeTypeID: [
          { required: true, message: "请选择费用类型", trigger: "change" },
        ],
        FeeItemID: [
          { required: true, message: "请选择费用项", trigger: "change" },
        ],
        tdate: [{ required: true, message: "请选择有效期", trigger: "change" }],
        FeeRuleID: [
          { required: true, message: "请选择费用规则", trigger: "change" },
        ],
      },
      customerList: [], //客户
      feeTypeList: [], //费用类型
      feeItemList: [], //费用项
      feeRuleList: [], //费用规则
      currencyList: [], //币别
      feeTypeWareList: [], //根据仓库加载费用类型
      feeItemTypeList: [], //根据费用类型加载费用项
      feeTypeRepList: [], //报表根据仓库加载费用类型
      feeItemRepList: [], //报表根据费用类型加载费用项
      addLoading: false,
      ruleTitle: [], //规则标题
      ruleData: [], //规则值
      total: 0,
      Orgdisabled: false,
      Editdisabled: false,
      batchStatusList: [], //审核状态
      feeItemBatchdisabled: false, //是否查询详情
      type: 0,
      //是否启用
      isStartList: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "禁用",
        },
      ],
      //是否过期
      isOverdueList: [
        {
          value: "true",
          label: "已过期",
        },
        {
          value: "false",
          label: "未过期",
        },
      ],
    };
  },
  methods: {
    judgeStr(val) {
      var aa = val + "";
      if (aa.indexOf("fixed20210916") != -1) {
        return true;
      } else {
        return false;
      }
    },
    //查询规则详情
    feeItemBatchdetails(feeItemBatchID) {
      this.feeItemBatchdisabled = true;
      this.Editdisabled = false;
      this.onGetFeeItemBatchById(feeItemBatchID, 2);
    },
    //报表选择仓库
    GetRepFeeType() {
      const { warehouseId } = this.filters;
      this.feeTypeRepList = this.feeTypeList.filter((m) => {
        return m.warehouseId === warehouseId;
      });
      this.filters.feeTypeID = "";
      this.filters.feeItemID = "";
      this.feeItemRepList = [];
    },
    //报表选择费用类型
    GetRepFeeItem() {
      const { feeTypeID } = this.filters;
      this.feeItemRepList = this.feeItemList.filter((m) => {
        return m.feeTypeID === feeTypeID;
      });
      this.filters.feeItemID = "";
    },

    //选择客户
    selectCustomer() {
      if (this.addForm.IsPublic === true) {
        this.addForm.OrgIDS = [];
        this.Orgdisabled = true;
      } else {
        this.Orgdisabled = false;
      }
    },
    //选择仓库
    GetFeeType() {
      this.feeTypeWareList = this.feeTypeList.filter((m) => {
        return m.warehouseId === this.addForm.WarehouseId&&m.isStart===true;
      });
      this.addForm.FeeTypeID = "";
      this.addForm.FeeItemID = "";
      this.feeItemTypeList = [];
    },
    //选择费用类型
    GetFeeItem() {
      this.feeItemTypeList = this.feeItemList.filter((m) => {
        return m.feeTypeID === this.addForm.FeeTypeID&&m.isStart===true;
      });
      this.addForm.FeeItemID = "";
    },
    //选择规则
    getFeeRuleTemp() {
      this.ruleTitle = [];
      this.ruleData = [];
      if (this.addForm.FeeRuleID != "") {
        getFeeRuleTemplateByFeeRuleId({
          feeRuleId: this.addForm.FeeRuleID,
          feeItemBatchID: this.addForm.FeeItemBatchID,
        }).then((res) => {
          if (res.data.Value.success) {
            this.ruleTitle = res.data.Value.response.RuleTemplate;
            this.ruleData = res.data.Value.response.BatchDetail;
            this.ruleTitle.forEach((item) => {
              if (item.DataSourceType === 1) {
                this.ruleData.forEach((ison) => {
                  ison[item.TemplateFieldName] =
                    item.CalculationValue + "fixed20210916"; //fixed20210916用来区分是不是固定值
                });
              }
            });
            this.maxRow = this.ruleData.length;
            this.total = this.ruleData.length;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },
    //添加规则
    addRuleTemp() {
      var row = JSON.parse(JSON.stringify(this.ruleData[0]));
      row.xh = this.maxRow + 1;
      row.FeeItemBatchDetailID = 0;
      this.ruleData.push(row);
      this.maxRow += 1;
      this.total = this.ruleData.length;
    },
    //删除规则
    delRuleTemp(xh) {
      const index = this.ruleData.findIndex((item) => item.xh === xh);
      if (index > -1) {
        this.ruleData.splice(index, 1);
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.total = this.ruleData.length;
      }
    },
    // 弹出添加费用
    addTaskdialog() {
      this.Editdisabled = false;
      this.feeItemBatchdisabled = false;
      this.addTaskdialogVisible = true;
      if (this.type !== 0) {
        if (this.$refs["addRuleForm"] !== undefined) {
          this.$refs["addRuleForm"].resetFields();
        }
         this.addForm.Remark="";
        this.ruleData = [];
        this.ruleTitle = [];
        this.feeTypeWareList = [];
        this.feeItemTypeList = [];
        this.total = 0;
      }
      this.addForm.FeeItemBatchID = 0;
      this.type = 0;
    },
    // 弹出修改费用
    editTaskdialog(row) {
      if (row.isStart == true) {
        this.$message({
          message: "请选择【禁用】的数据！",
          type: "error",
        });
        return;
      }

      this.Editdisabled = true;
      this.feeItemBatchdisabled = false;

      this.onGetFeeItemBatchById(row.feeItemBatchID, 1);
    },
    // 弹出复制新增费用
    copyTaskdialog(row) {
      this.feeItemBatchdisabled = false;
      this.Editdisabled = false;
      this.onGetFeeItemBatchById(row.feeItemBatchID, 2);
    },
    //提交
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      if (para.IsPublic == false && para.OrgIDS.length == 0) {
        this.$message({
          message: "请选择客户！",
          type: "error",
        });
        return;
      }
      if (this.ruleData.length == 0) {
        this.$message({
          message: "请配置费用规则",
          type: "error",
        });
      }
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            if (para.tdate != null && para.tdate != "null") {
              para.EffectiveDate = para.tdate[0];
              para.ExpirationDate = para.tdate[1];
            }

            para.BatchDetail = this.ruleData;
            var user = JSON.parse(window.localStorage.user);
            if (!user && user.id == 0) {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }
            this.addLoading = true;

            AddFeeItemBatch(para).then((res) => {
              this.addLoading = false;
              if (res.data.success) {
                this.addTaskdialogVisible = false;
                this.$refs["addRuleForm"].resetFields();
                this.addForm.Remark="";
                this.ruleData = [];
                this.ruleTitle = [];
                this.feeTypeWareList = [];
                this.feeItemTypeList = [];
                this.total = 0;
                this.initTable();
                this.$message({
                  message: "设置成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //重算
    recalculation(row) {
      if (row.status != 20) {
        this.$message({
          message: "请选择审核状态是【已审核】的数据！",
          type: "error",
        });
        return;
      }
      if (row.isStart == false) {
        this.$message({
          message: "请选择【启用】的数据！",
          type: "error",
        });
        return;
      }
      this.$confirm(
        "将重新计算【" +
          row.warehouseName +
          row.effectiveDate +
          "至" +
          row.expirationDate +
          "】费用类型【" +
          row.feeTypeName +
          "】费用项【" +
          row.feeItemName +
          "】，请确认？",
        "提示",
        {}
      ).then(() => {
        recostingFeeFlowDetail({
          feeItemBatchID: row.feeItemBatchID,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    loadingReviewdialog() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].status != 40) {
        this.$message({
          message: "请选择状态是【已装车】的数据！",
          type: "error",
        });
        return;
      }
      var random = Math.random();
      this.loadingReviewWinodw =
        "/Outbound/LoadingReview?random=" +
        random +
        "&loadCarInfoID=" +
        row[0].loadCarInfoID;
      this.loadingReviewdialogVisible = true;
    },
    //查询列表
    initTable() {
      const {
        warehouseId,
        feeTypeID,
        feeItemID,
        feeRuleID,
        orgID,
        status,
        isStart,
        isOverdue,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        warehouseId: warehouseId,
        feeTypeID: feeTypeID,
        feeItemID: thereAre(feeItemID),
        feeRuleID: thereAre(feeRuleID),
        orgID: orgID,
        status: thereAre(status),
        isStart: thereAre(isStart),
        isOverdue: thereAre(isOverdue),
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getFeeItemBatchAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let feeItemBatchID = row.map((item) => item.feeItemBatchID).join(",");

      const {
        warehouseId,
        feeTypeID,
        feeItemID,
        feeRuleID,
        orgID,
        status,
        isStart,
        isOverdue,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: 60001,
        warehouseId: warehouseId,
        feeTypeID: feeTypeID,
        feeItemID: thereAre(feeItemID),
        feeRuleID: thereAre(feeRuleID),
        orgID: orgID,
        status: thereAre(status),
        isStart: thereAre(isStart),
        isOverdue: thereAre(isOverdue),
        feeItemBatchID: feeItemBatchID,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportFeeItemBatchAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //审核费用规则
    examineStatus() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].status != 10) {
        this.$message({
          message: "请选择审核状态是【待审核】的数据！",
          type: "error",
        });
        return;
      }
      this.$confirm(
        "确认要审核费用规则" + row[0].batchNumber + "吗？",
        "提示",
        {}
      ).then(() => {
        examineFeeItemBatchStatus({
          feeItemBatchID: row[0].feeItemBatchID,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    //启用费用规则
    enableIsStart() {
      this.operationIsStart(true);
    },
    //禁用费用规则
    disableIsStart() {
      this.operationIsStart(false);
    },
    //启用禁用费用规则
    operationIsStart(isStart) {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].status != 20) {
        this.$message({
          message: "请选择审核状态是【已审核】的数据！",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].isStart == isStart) {
        let tips = isStart ? "禁用" : "启用";
        this.$message({
          message: "请选择【" + tips + "】的数据！",
          type: "error",
        });
        return;
      }
      let title = isStart ? "启用" : "禁用";
      this.$confirm(
        "确认要" + title + "费用规则" + row[0].batchNumber + "吗？",
        "提示",
        {}
      ).then(() => {
        examineFeeItemBatchIsStart({
          feeItemBatchID: row[0].feeItemBatchID,
          isStart,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },

    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList.filter((m) => {
        return m.operateType === 1;
      });
      let para = {
        IsAll: false,
      };
      getCustomerList(para).then((res) => {
        this.customerList = res.data.response;
      });
      this.$nextTick(function () {
        getFeeItemBatchBasis("").then((res) => {
          this.feeTypeList = res.data.response.feeTypeList;
          this.feeItemList = res.data.response.feeItemList;
          this.feeRuleList = res.data.response.feeRuleList;
          this.currencyList = res.data.response.currencyList;
          this.batchStatusList = res.data.response.batchStatusList;
        });
      });
    },
    //查询费用规则信息
    onGetFeeItemBatchById(feeItemBatchID, type) {
      if (feeItemBatchID == 0 || feeItemBatchID == undefined) {
        this.$message({
          message: "费用配置ID错误",
          type: "error",
        });
        return;
      }

      let pata = {
        feeItemBatchID: feeItemBatchID,
        type: type,
      };
      this.type = type;
      getFeeItemBatchByFeeItemBatchId(pata).then((res) => {
        if (res.data.success) {
          this.addTaskdialogVisible = true;
          this.$nextTick(() => {
            this.addForm.FeeItemBatchID = res.data.response.feeItemBatchID;
            this.addForm.FeeCustomerName = res.data.response.feeCustomerName;
            this.addForm.WarehouseId = res.data.response.warehouseId;
            this.GetFeeType();
            this.addForm.Currency = res.data.response.currency;
            this.addForm.FeeTypeID = res.data.response.feeTypeID;
            this.GetFeeItem();
            this.addForm.FeeItemID = res.data.response.feeItemID;
            this.addForm.FeeRuleID = res.data.response.feeRuleID;
            this.getFeeRuleTemp();
            this.addForm.OrgIDS = res.data.response.orgIDS;
            this.addForm.IsPublic = res.data.response.isPublic;
            this.selectCustomer();
            this.addForm.Remark = res.data.response.remark;
            this.addForm.tdate = [];
            this.addForm.tdate.push(res.data.response.effectiveDate);
            this.addForm.tdate.push(res.data.response.expirationDate);
            if (type === 2) {
              this.addForm.FeeItemBatchID = 0;
            }
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBasicdatalist();
  },
};
</script>